import { FC, ReactNode, createContext, useContext } from "react";
import { CheckboxInput, CheckboxLabel, CheckboxWrapper } from "./styled";

type CheckboxGroupContextType = {
  value: (string | number)[];
  onChange: (value: (string | number)[]) => void;
};

const CheckboxGroupContext = createContext<CheckboxGroupContextType | null>(null);

type Props = {
  value: string | number;
  children: ReactNode;
};

const Checkbox: FC<Props> & {
  Group: FC<CheckboxGroupProps>;
} = ({ value, children }) => {
  const group = useContext(CheckboxGroupContext);

  const isChecked = group?.value.includes(value);
  const handleChange = () => {
    if (!group) return;
    if (isChecked) {
      group.onChange(group.value.filter((v) => v !== value));
    } else {
      group.onChange([...group.value, value]);
    }
  };

  return (
    <CheckboxWrapper>
      <CheckboxInput
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
      />
      <CheckboxLabel>{children}</CheckboxLabel>
    </CheckboxWrapper>
  );
};

type CheckboxGroupProps = {
  value: (string | number)[];
  onChange: (value: (string | number)[]) => void;
  children: ReactNode;
};

Checkbox.Group = ({ value, onChange, children }) => {
  return (
    <CheckboxGroupContext.Provider value={{ value, onChange }}>
      {children}
    </CheckboxGroupContext.Provider>
  );
};

export default Checkbox;
